<template>
  <div>
    <ContentHeader :material-nav="true" :show-back="false" />
    <div class="content-container">
      <div class="menu-container">
        <el-card shadow="hover">
          <div class="card-title">Non Menu 订单</div>
          <div class="cam-row">
            <router-link to="/material/non-menu-less">
              <div class="cam-col">
                <div class="card-icon">
                  <i class="iconfont iconzu101" style="color: #F2711C" />
                </div>
                <div class="card-text">提交申请</div>
              </div>
            </router-link>
            <!-- <router-link to="/material/non-menu-less"> -->
            <!-- <div class="cam-col">
              <div class="card-icon">
                <i class="iconfont iconzu3" />
              </div>
              <div class="card-text">待下单订单</div>
            </div> -->
            <!-- </router-link> -->
          </div>
        </el-card>
        <el-card shadow="hover">
          <div class="card-title">大于五万需求申请</div>
          <div class="cam-row">
            <router-link to="/material/non-menu-more">
              <div class="cam-col" style="border-right: 1px solid #ddd">
                <div class="card-icon">
                  <i class="iconfont iconzu101" style="color: #F2711C" />
                </div>
                <div class="card-text">提交申请</div>
              </div>
            </router-link>
            <router-link to="/material/non-menu-more-list">
              <div class="cam-col">
                <div class="card-icon">
                  <i class="iconfont iconzu3" />
                </div>
                <div class="card-text">已申请列表</div>
              </div>
            </router-link>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '../../components/content-header'
export default {
  name: 'non-menu',
  components: {
    ContentHeader
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.menu-container {
  display: flex;
  justify-content: center;
  .el-card {
    width: 400px;
    height: 300px;
    cursor: pointer;
    text-align: center;
    .card-title {
      font-size: $font-14;
      padding-bottom: 20px;
      line-height: 25px;
    }
    .cam-row {
      height: 180px;
      .cam-col {
        width: 50%;
        height: 100%;
        display: inline-block;
        box-sizing: border-box;
        text-align: center;
        .card-icon {
          padding: 60px 0 10px 0;
        }
      }
    }
    .card-icon {
      padding: 80px 0 10px 0;
      margin-bottom: $content-middle;
      .iconfont {
        font-size: 36px;
        transition: all 0.4s;
        color: $base-blue;
      }
    }
    .card-text {
      font-size: $font-16;
    }
  }
  .el-card:first-child {
    margin-right: $page-middle;
  }
}
a {
  text-decoration: none;
  color: #000;
}
</style>
